import React from "react";
import AttendanceMonthlyReportList from "./AttendanceMonthlyReportList";

function EmployeeMonthlyAttendanceReportList() {
  return (
    <AttendanceMonthlyReportList
      defaultPersonTypeId="1"
      heading="Employee Monthly Attendance Report"
      routePath="/attendance/monthly-report/employees"
    />
  );
}

export default EmployeeMonthlyAttendanceReportList;

